import { createContext, useContext } from "react";
import { EntityAttributes } from "./types";

export const Context = createContext<EntityAttributes | null>(null);

export function useEntityAttributesContext() {
  const ctx = useContext(Context);

  if (ctx === null) {
    throw new Error(
      "useEntityAttributesContext must be used within EntityAttributesProvider",
    );
  }

  return ctx;
}
